import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import {
	ChartBarOutline,
	ChartSquareBarOutline,
	ClipboardCheckOutline,
	PresentationChartBarOutline,
	TrendingUpOutline,
	UserGroupOutline,
	ViewGridOutline,
} from '@bonusly/design-system';
import { useBuildRecognizeURL } from '@bonusly/url';
import { useCurrentCompany, useCurrentUser } from '@bonusly/who-am-i';

import { useIsRecognize } from '../../../../hooks/use-is-recognize';
import { Route } from '../../config/router';
import { NavMenu } from './NavMenu';
import { NavMenuItem } from './NavMenuItem';

export const AnalyticsMenu: FC = () => {
	const recognizeURL = useBuildRecognizeURL();
	const { t } = useTranslation('navigation');
	const isRecognize = useIsRecognize();
	const location = useLocation();
	const isRecognizeActive = isRecognize && location.pathname.startsWith('/analytics');
	const { hide_competitive_features: hideCompetitiveFeatures } = useCurrentCompany();
	const { global_admin: isAdmin } = useCurrentUser();
	const hideLeaderboard = hideCompetitiveFeatures && !isAdmin;

	return (
		<NavMenu
			aria-label={t('analytics_menu.button_label')}
			icon={<ChartSquareBarOutline />}
			id="navbar-analytics-menu"
			isActive={isRecognizeActive}
			label={t('links.analytics')}
		>
			<NavMenuItem icon={<ViewGridOutline />} to={recognizeURL(Route.Analytics)} key="team-dashboard">
				{t('analytics_menu.team_dashboard')}
			</NavMenuItem>

			{!hideLeaderboard && (
				<NavMenuItem icon={<ChartBarOutline />} to={recognizeURL(Route.AnalyticsLeaderboard)} key="leaderboard">
					{t('analytics_menu.leaderboard')}
				</NavMenuItem>
			)}

			<NavMenuItem icon={<ClipboardCheckOutline />} to={recognizeURL(Route.AnalyticsEngagement)} key="participation">
				{t('analytics_menu.participation')}
			</NavMenuItem>

			<NavMenuItem icon={<PresentationChartBarOutline />} to={recognizeURL(Route.AnalyticsTotals)} key="recognition">
				{t('analytics_menu.recognition')}
			</NavMenuItem>

			<NavMenuItem icon={<UserGroupOutline />} to={recognizeURL(Route.AnalyticsOrganization)} key="organization-graph">
				{t('analytics_menu.organization_graph')}
			</NavMenuItem>

			<NavMenuItem icon={<TrendingUpOutline />} to={recognizeURL(Route.AnalyticsWords)} key="top-words">
				{t('analytics_menu.top_words')}
			</NavMenuItem>
		</NavMenu>
	);
};
